import { render, staticRenderFns } from "./ImsDescriptionModal.vue?vue&type=template&id=21d67bdb"
import script from "./ImsDescriptionModal.vue?vue&type=script&lang=js"
export * from "./ImsDescriptionModal.vue?vue&type=script&lang=js"
import style0 from "./ImsDescriptionModal.vue?vue&type=style&index=0&id=21d67bdb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports